<template>
  <div class="login-page" :style="bgStyle">
    <el-card class="login-card">
      <div class="login-title">总后台登录</div>
      <el-form label-position="top">
        <el-form-item label="账号">
          <el-input v-model="form.username" placeholder="请输入管理员账号" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" placeholder="请输入登录密码" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-button" block @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>


export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      bgStyle: {},
      form: {
        username: "",
        password: ""
      }
    };
  },
  computed: {},
  mounted() {
    const gradients = [
      ["#dfe9ff", "#d8f3ff", "#ffe6ef"],
      ["#e2f3ff", "#d9f7f0", "#ffe6cc"],
      ["#e6e9ff", "#dbeeff", "#dff6ff"],
      ["#ffe9dc", "#e1f0ff", "#e3ffef"],
      ["#e2ecff", "#e1e8ff", "#ffe3ef"],
      ["#e1ffe9", "#d9eeff", "#ffe1dd"]
    ];
    const pick = gradients[Math.floor(Math.random() * gradients.length)];
    this.bgStyle = {
      "--g1": pick[0],
      "--g2": pick[1],
      "--g3": pick[2]
    };
  },
  created() {
    this.checkLogin()
  },
  methods: {
    goHome() {
      this.$router.push("/dashboard");
    },
    checkLogin() {
      const that = this
      this.$http_get('/admin/account/check_login').then(res => {
        console.log('res', res)
        if (res.data == '已登录') {
          that.goHome();
        }
      })
    },

    login() {
      const that = this
      this.$http_post('/admin/login/login', this.form, 1).then(res => {
        console.log('res', res)
        if (res && res.code == 200 && res.data.token) {
          localStorage.setItem("tokena", res.data.token);

          that.goHome();
        }
      })
    }
  }
};
</script>

<style>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(120deg, var(--g1), var(--g2), var(--g3));
  background-size: 200% 200%;
  animation: loginGradient 18s ease infinite;
}

.login-card {
  width: 360px;
}

.login-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.login-button {
  width: 100%;
}

@keyframes loginGradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
